/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props) {
  return {
    variables: { id: props.appointment_id },
    pause: !props.appointment_id,
  }
}
